/**
 * Class of Dropdown-A-1 molecule
 */

class DropdownA {
    // The Main container of the block
    block;
    // Classes that makes dropdown visible (todo: have to change eslint settings and make these properties private)
    _dropdownOpenedClasses = 'm-dropdown-a-1--opened';
    // Classes that are needed for hiding a dropdown
    _dropdownClosedClasses = 'm-dropdown-a-1--closed';

    constructor(block) {
        this.container = block;

        this._initElements();
        this._initListeners();
    }

    /**
     * Initializing all the needed elements of the class
     */
    _initElements() {
        this.button = this.container.querySelector(
            `[data-role='dropdown-button']`,
        );
        this.dropdownList = this.container.querySelector(
            `[data-role='dropdown-list']`,
        );
        this.arrow = this.container.querySelector(
            `[data-role='dropdown-arrow']`,
        );
    }

    /**
     * Adding event Listeners
     */
    _initListeners() {
        document.addEventListener(
            'click',
            this._documentClicksHandler.bind(this),
        );
    }

    /**
     * Function that control opened/closed states of a dropdown on documents clicks
     *
     * @param event
     */
    _documentClicksHandler(event) {
        let button = event.target.closest(`[data-role='dropdown-button']`);
        if (button !== this.button) {
            this._hideDropdown();
            return;
        }

        if (this.container.classList.contains(this._dropdownClosedClasses)) {
            this._showDropdown();
        } else {
            this._hideDropdown();
        }
    }

    /**
     * Show Dropdown
     */
    _showDropdown() {
        this.container.classList.add(this._dropdownOpenedClasses);
        this.container.classList.remove(this._dropdownClosedClasses);
        jQuery(this.dropdownList).slideDown();
        this.button
            .querySelector(`[data-role='dropdown-arrow']`)
            .classList.add('rotate-180');
    }

    /**
     * Hide Dropdown
     */
    _hideDropdown() {
        this.container.classList.remove(this._dropdownOpenedClasses);
        this.container.classList.add(this._dropdownClosedClasses);
        jQuery(this.dropdownList).slideUp();
        this.button
            .querySelector(`[data-role='dropdown-arrow']`)
            .classList.remove('rotate-180');
    }
}

function dropdownA() {
    const dropdowns = document.querySelectorAll(`[data-role='dropdown-a-1']`);
    [...dropdowns].map((dropdown) => {
        new DropdownA(dropdown);
    });
}

export default dropdownA;
